import {combineReducers} from 'redux'
import types from 'actions/types'
import {isNil, get} from 'lodash'
import {createPivotTableReducer} from "reducers/pivotTable"
import Immutable from "seamless-immutable"

export const jobCardOrderItemsPivotTableKey = 'dialogs.viewJobCard.orderItemsPivotTable'
export const jobCardDialogDocumentsPivotTableKey = 'dialogs.viewJobCard.pivotTable'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG:
      return true
    case types.PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG:
      return false
    default:
      return state
  }
}

export const jobCard = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG:
      return get(action, 'jobCard', null)
    case types.PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG:
      return null

      // Either this or another user has updated this job card
      // override the state immediately
    case types.PRODUCTION_UPDATE_JOB_CARD_SUCCESS:
      return !isNil(state) && state.id === action.data.result.id
          ? action.data.result
          : state

    default:
      return state
  }
}

export const order = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG:
      return get(action, 'order', null)
    case types.PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG:
      return null
    case types.QUOTING_QUOTE_UPDATE_ORDER:
      return !isNil(state) && state.id === action.order.id
          ? action.order
          : state

      // Either this or another user has updated this job card
      // override the state immediately
    case types.PRODUCTION_UPDATE_JOB_CARD_SUCCESS:
      return !isNil(state) && state.id === get(action, 'data.result.order.id')
          ? action.data.result.order
          : state
    default:
      return state
  }
}

export const jobCardReadOnly = (state = false, action) => {
  switch (action.type) {
    case types.PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG:
      return get(action, 'jobCardReadOnly', false)
    case types.PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG:
      return false
    default:
      return state
  }
}

export const documentSubFolder = (state = null, action) => {
  switch (action.type) {
    case types.JOB_CARD_DOCUMENTS_SET_SELECTED_SUB_FOLDER:
      return action.path
    default:
      return state
  }
}

export const isJobTabAddressVisible = (state = true, action) => {
  switch (action.type) {
    case types.PRODUCTION_TOGGLE_JOB_CARD_JOB_ADDRESS_VISIBILITY:
      return !state
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  jobCard,
  order,
  jobCardReadOnly,
  documentSubFolder,
  pivotTable: createPivotTableReducer({
    key: jobCardDialogDocumentsPivotTableKey,
    defaultSortColumn: 'folderName',
  }),
  orderItemsPivotTable: createPivotTableReducer({
    key: jobCardOrderItemsPivotTableKey,
    defaultSortColumn: Immutable('itemId'),
  }),
  isJobTabAddressVisible,
})
